import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const PLACEHOLDER_SURVEY_NAME = 'survey name'
export const LANGUAGE = 'language'
export const LANGUAGE_PORTUGUESE = 'portuguese'
export const LANGUAGE_ENGLISH = 'english'
export const LANGUAGE_SPANISH = 'spanish'
export const TYPE = 'type'
export const CANCEL = 'cancel'
export const CREATE = 'create'
export const COPY = 'copy'
export const REQUIRED_FIELDS = 'required fields'

export default {
  [PORTUGUESE]: {
    [PLACEHOLDER_SURVEY_NAME]: 'Novo nome da pesquisa',
    [LANGUAGE]: 'Idioma',
    [LANGUAGE_PORTUGUESE]: 'Português',
    [LANGUAGE_ENGLISH]: 'Inglês',
    [LANGUAGE_SPANISH]: 'Espanhol',
    [TYPE]: 'Tipo',
    [CANCEL]: 'Cancelar',
    [CREATE]: 'Criar',
    [COPY]: 'Copiar',
    [REQUIRED_FIELDS]: 'Por favor preencha todos os campos obrigatórios',
  },

  [ENGLISH]: {
    [PLACEHOLDER_SURVEY_NAME]: 'New Survey Name',
    [LANGUAGE]: 'Language',
    [LANGUAGE_PORTUGUESE]: 'Portuguese',
    [LANGUAGE_ENGLISH]: 'English',
    [LANGUAGE_SPANISH]: 'Spanish',
    [TYPE]: 'Type',
    [CANCEL]: 'Cancel',
    [CREATE]: 'Create',
    [COPY]: 'Copy',
    [REQUIRED_FIELDS]: 'Please fill in all the required fields',
  },

  [SPANISH]: {
    [PLACEHOLDER_SURVEY_NAME]: 'Nombre de la encuesta',
    [LANGUAGE]: 'Idioma',
    [LANGUAGE_PORTUGUESE]: 'Portugués',
    [LANGUAGE_ENGLISH]: 'Inglés',
    [LANGUAGE_SPANISH]: 'Español',
    [TYPE]: 'Tipo',
    [CANCEL]: 'Cancelar',
    [CREATE]: 'Crear',
    [REQUIRED_FIELDS]: 'Por favor, rellene todos los campos obligatorios',
    [COPY]: 'Dupdo',
  },
}
